import { toast } from "react-toastify";
import ConfirmToast from "./ConfirmToast";
import ApiKeyToast from "./ApiKeyToast";

export const notify = {
  success: (msg: string) => toast.success(msg, { autoClose: 5000 }),

  error: (msg: string) => toast.error(msg, { autoClose: 10000 }),

  warning: (msg: string) => toast.warning(msg, { autoClose: 8000 }),

  confirm: (msg: string, onConfirm: () => void) => {
    toast(<ConfirmToast message={msg} onConfirm={onConfirm} />, {
      autoClose: false,
      closeOnClick: false,
      closeButton: true,
    });
  },

  apiKey: (apiKey: string) => {
    toast(<ApiKeyToast apiKey={apiKey} />, {
      autoClose: false,
      closeOnClick: false,
      closeButton: false,
    });
  },
};
